import { when, of, any, intersection, complement, flip, includes } from 'ramda'

const isElementOf = flip(includes)

export enum AuthPermissionsLogicType {
  OR = 'OR',
  AND = 'AND',
}

interface DeriveAuthPermissionsAvailabilityParams {
  scopes?: string[] | null
  requiredPermissions: string[] | string
  logic?: AuthPermissionsLogicType
}

const isNotArray = complement(Array.isArray)

/**
 * Returns a boolean that says whether the given scopes contain required permissions
 *
 * By default it checks if all the permissions are available.
 * This can be controlled using opts.logic
 */
export const deriveAuthPermissionsAvailability = ({
  scopes,
  requiredPermissions,
  logic = AuthPermissionsLogicType.AND,
}: DeriveAuthPermissionsAvailabilityParams) => {
  if (requiredPermissions) {
    const permissions = when(isNotArray, of)(requiredPermissions)

    if (logic === AuthPermissionsLogicType.AND) {
      return (
        intersection(scopes || [], permissions).length !== permissions.length
      )
    }

    if (logic === AuthPermissionsLogicType.OR) {
      return !any(isElementOf(scopes || []))(permissions)
    }

    console.warn('INVALID LOGIC FOR PERMISSIONS VALIDATION', logic) // eslint-disable-line no-console
    return true
  }

  return !scopes || !scopes.length
}
